export interface Data {
  [key: string]: string | number;
}

type BarDatum = { [key: string]: string | number };

const parseKeyToColomns = (
  data: Data[],
  keys: any[],
  indexBy: string,
  parseKeyToColumn?: boolean
) => {
  if (parseKeyToColumn) {
    const uniqueKeys = new Set<string>();
    const grouped = data.reduce<Record<string, BarDatum>>((acc, item) => {
      const groupKey = String(item[indexBy]);
      const columnKey = String(item[keys[0]]);
      const value = Number(item[keys[1]]) as number;

      uniqueKeys.add(columnKey);

      if (!acc[groupKey]) {
        acc[groupKey] = { [indexBy]: groupKey };
      }

      acc[groupKey][columnKey] =
        ((acc[groupKey][columnKey] || 0) as number) + value;
      return acc;
    }, {});

    const parsedData = Object.values(grouped);
    const newKeys = Array.from(uniqueKeys);
    return { parsedData, newKeys };
  }
  const parsedData = data;
  const newKeys = keys;
  return { parsedData, newKeys };
};

export default parseKeyToColomns;
